import { useMountEffect } from '@timelyapp/react';
import { useState } from 'react';

export const useIsListEmpty = (listLength: number, isLoading: boolean) => {
  const [isInitialised, setIsInitialised] = useState(false);
  const isEmpty = isInitialised && !isLoading && listLength === 0;

  useMountEffect(() => {
    setIsInitialised(true);
  });
  return { isEmpty, initialisedAndLoading: isInitialised && isLoading };
};
